"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneMaskFormat = void 0;
var PhoneMaskFormat;
(function (PhoneMaskFormat) {
    PhoneMaskFormat["USA"] = "USA";
})(PhoneMaskFormat = exports.PhoneMaskFormat || (exports.PhoneMaskFormat = {}));
